import { render, staticRenderFns } from "./BaseFrontOfficeExpansionPanel.vue?vue&type=template&id=2f877a2c&scoped=true"
import script from "./BaseFrontOfficeExpansionPanel.vue?vue&type=script&lang=js"
export * from "./BaseFrontOfficeExpansionPanel.vue?vue&type=script&lang=js"
import style0 from "./BaseFrontOfficeExpansionPanel.vue?vue&type=style&index=0&id=2f877a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f877a2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader})
